<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES Y RAMAS EN ORILLAS (AL FRENTE) -->
    <!-- Superior Izquierda -->
    <div class="deco-wrapper deco-lt">
      <img src="@/assets/rama.png" class="rama-img" alt="Rama" loading="lazy" />
      <img src="@/assets/monio.png" class="flor-img" alt="Moño" loading="lazy" />
    </div>

    <!-- Inferior Derecha -->
    <div class="deco-wrapper deco-rb">
      <img src="@/assets/rama.png" class="rama-img" alt="Rama" loading="lazy" />
      <img src="@/assets/monio.png" class="flor-img" alt="Moño" loading="lazy" />
    </div>

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        :ref="el => { if (el) collageItems[index] = el }"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>

    <!-- MODAL TELETRANSPORTADO -->
    <Teleport to="body">
      <div
        v-if="isImageEnlarged"
        class="image-modal"
        @click="closeModal"
      >
        <img
          :src="images[currentIndex]"
          class="enlarged-image"
          alt="Imagen ampliada"
        />
      </div>
    </Teleport>

    <div class="rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/30994_11zon.webp')
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)
    let io = null

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      const validItems = collageItems.value.filter(Boolean)
      const decos = rootRef.value ? rootRef.value.querySelectorAll('.deco-wrapper') : []

      // Inicialización ligera procesada en GPU sin blurs
      gsap.set([bgRef.value, ...decos, ...validItems], { force3D: true })
      gsap.set(bgRef.value, { autoAlpha: 0 })
      gsap.set(decos, { autoAlpha: 0, scale: 0.9, y: 15 })
      gsap.set(validItems, { autoAlpha: 0, y: 20 })

      io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // Entrada rápida
          tl.to(bgRef.value, { autoAlpha: 1, duration: 0.3 })
            .to(validItems, {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.08
            }, '-=0.2')
            .to(decos, {
              autoAlpha: 1,
              scale: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.1
            }, '-=0.3')

          io.disconnect() // Mata el observador inmediatamente para liberar memoria
        })
      }, { threshold: 0.05 }) // Umbral ligero que activa la animación al instante

      if (rootRef.value) io.observe(rootRef.value)
    })

    onUnmounted(() => {
      if (io) io.disconnect()
    })

    return {
      images,
      rootRef,
      bgRef,
      collageItems,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: hidden;
  contain: layout style; /* Aísla cálculos de diseño */
}

.bg-rosa {
  position: absolute;
  inset: 0;
  background: #f0c9d3;
  z-index: 0;
}

/* 🌸 DECORACIONES */
.deco-wrapper {
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.flor-img {
  width: 120px;
  max-width: 35vw;
  position: relative;
  z-index: 12;
  height: auto;
  object-fit: contain;
}

.rama-img {
  position: absolute;
  width: 250px !important;
  max-width: 80vw;
  height: auto;
  object-fit: contain;
  z-index: 11;
  margin-top: 120px;
}

.deco-lt {
  top: 2vh;
  left: -10px;
}

.deco-rb {
  bottom: 6vh;
  right: -10px;
}

.deco-rb .rama-img {
  margin-top: 0px;
  transform: rotate(180deg);
}

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 8vh 0;
}

.collage-item {
  grid-column: span 12;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.collage-image {
  width: 85%;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.12);
  display: block;
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 12px;
  object-fit: contain;
}

.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #f0c9d3;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
  z-index: 1;
}
</style>